import { i18n } from '@fs/zion-locale'

export default {
  dialogClose: () => i18n.t('ImageOrganizeFooter.dialogClose', 'Close'),
  dialogCorrectMetadata: () => i18n.t('ImageOrganizeFooter.dialogCorrectMetadata', 'Correct Metadata'),
  dialogCompleteHeading: () => i18n.t('ImageOrganizeFooter.dialogCompletedHeading', 'Division complete'),

  dialogReturnToSearch: () => i18n.t('ImageOrganizeFooter.exitDivideDialogMessage', 'Exit'),
  dialogStatusErrorHeading: () =>
    i18n.t('ImageOrganizeFooter.dialogStatusErrorHeading', 'Error retrieving division progress.'),
  dialogUpdateErrorHeading: () => i18n.t('ImageOrganizeFooter.dialogUpdateErrorHeading', 'Error dividing image group.'),

  noDivisionsTitle: () => i18n.t('ImageOrganizeFooter.noDivisionsDialog.title', 'No divisions were added'),
  noDivisionsBody1: () =>
    i18n.t(
      'ImageOrganizeFooter.noDivisionsDialog.body1',
      'During this step, image groups can be divided into smaller subgroups of related images.'
    ),
  noDivisionsBody2: () =>
    i18n.t(
      'ImageOrganizeFooter.noDivisionsDialog.body2',
      'If all thumbnails have been reviewed and this group does not need to be divided, please continue.'
    ),
  cancel: () => i18n.t('common-ui:cancel.action'),
  continue: () => i18n.t('common-ui:continue.action'),
  reset: () => i18n.t('common-ui:continue.reset', 'reset'),
  resetMessageHeader: () => i18n.t('StatusAlreadySet.resetItemMessageHeader', "Reset item's status"),
  resetMessageBody: (itemStatus) =>
    i18n.t(
      'StatusAlreadySet.resetMessageBody',
      "Are you sure you want to reset this item's status? This item will no longer be {status}.",
      { status: itemStatus ? 'skipped' : 'marked correct' }
    ),
  dialogLoadingMessage: (percentComplete) =>
    i18n.t('ImageOrganizeFooter.dialogLoadingMessage', '{percentComplete}% complete', { percentComplete }),
  dialogCompleteContent: (count) =>
    i18n.t(
      'ImageOrganizeFooter.dialogCompletedMetadatContentText',
      'The image group was successfully divided into {count} items. Would you like to correct the metadata for this group or exit the Image Organize tool?',
      { count }
    ),
  dialogCompleteWithoutDivision: () =>
    i18n.t(
      'ImageOrganizeFooter.dialogCompleteWithoutDivision',
      'Would you like to correct the metadata for this group or exit the Image Organize tool?'
    ),

  dialogInProgressContent: () =>
    i18n.t(
      'ImageOrganizeFooter.dialogInProgressContent',
      'Please wait while the images are divided into groups. This should only take a few moments.'
    ),
  dialogInProgressHeading: () =>
    i18n.t('ImageOrganizeFooter.dialogProgressHeading', 'Image group division in progress'),
  updateErrorMessage: () =>
    i18n.t(
      'ImageOrganizeFooter.updateErrorMessage',
      'We were unable to submit your image group divisions. Please try again later.'
    ),
  statusErrorMessage: () =>
    i18n.t(
      'ImageOrganizeFooter.statusErrorMessage',
      'We are unable to display progress updates as the image group is divided. Your changes have been saved,' +
        ' and we will continue processing the divisions you submitted. No further action is needed.'
    ),

  summary: () => i18n.t('CorrectMetadataFinishedDialog.summary', 'Summary'),
  heresASummary: (number) =>
    i18n.t('CorrectMetadataFinishedDialog.subHeading', "Here's a summary of the {number} items in this group:", {
      number,
    }),
  continueEditing: () => i18n.t('CorrectMetadataFinishedDialog.continueEditing', 'Continue Editing'),
  finish: () => i18n.t('CorrectMetadataFinishedDialog.finish', 'Finish'),
  correctMultiple: (number) =>
    i18n.t('CorrectMetadataFinishedDialog.numMarkedCorrectMultipleText', '{number} items were marked correct.', {
      number,
    }),
  correctSingle: () => i18n.t('CorrectMetadataFinishedDialog.numMarkedCorrectSingleText', '1 item was marked correct.'),
  skippedMultiple: (number) =>
    i18n.t('CorrectMetadataFinishedDialog.SkippedMultipleItemsText', '{number} items were skipped.', {
      number,
    }),
  skippedSingle: () => i18n.t('CorrectMetadataFinishedDialog.onlySkippedSingleText', '1 item was skipped.'),
  remainingMultiple: (number) =>
    i18n.t('CorrectMetadataFinishedDialog.numRemainingMultipleText', '{number} items still need to be reviewed.', {
      number,
    }),
  remainingSingle: () =>
    i18n.t('CorrectMetadataFinishedDialog.numRemainingSingleText', '1 item still needs to be reviewed.'),
  inProgressByOthersSingle: () =>
    i18n.t('CorrectMetadataFinishedDialog.oneInProgressByOthersSingleText', '1 item is in progress by another user.'),
  inProgressByOthersMultiple: (number) =>
    i18n.t(
      'CorrectMetadataFinishedDialog.numInProgressByOthersSingleText',
      '{number} items are in progress by other users.',
      { number }
    ),
  inProgressByOthersSubtext: () =>
    i18n.t('CorrectMetadataFinishedDialog.inProgressByOthersSubtext', 'You can still submit your changes.'),
  groupDataStatusError: () => i18n.t('CorrectMetadataFinishedDialog.statusError', 'Error retrieving item statuses.'),
  groupDataFinishError: () =>
    i18n.t('CorrectMetadataFinishedDialog.finishError', 'Error returning skipped and unreviewed items.'),
}
